import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fdfcfe' },
    '2': { value: '#faf8ff' },
    '3': { value: '#f4f0fe' },
    '4': { value: '#ebe4ff' },
    '5': { value: '#e1d9ff' },
    '6': { value: '#d4cafe' },
    '7': { value: '#c2b5f5' },
    '8': { value: '#aa99ec' },
    '9': { value: '#6e56cf' },
    '10': { value: '#654dc4' },
    '11': { value: '#6550b9' },
    '12': { value: '#2f265f' },
    a1: { value: '#5500aa03' },
    a2: { value: '#4900ff07' },
    a3: { value: '#4400ee0f' },
    a4: { value: '#4300ff1b' },
    a5: { value: '#3600ff26' },
    a6: { value: '#3100fb35' },
    a7: { value: '#2d01dd4a' },
    a8: { value: '#2b00d066' },
    a9: { value: '#2400b7a9' },
    a10: { value: '#2300abb2' },
    a11: { value: '#1f0099af' },
    a12: { value: '#0b0043d9' },
  },
  dark: {
    '1': { value: '#14121f' },
    '2': { value: '#1b1525' },
    '3': { value: '#291f43' },
    '4': { value: '#33255b' },
    '5': { value: '#3c2e69' },
    '6': { value: '#473876' },
    '7': { value: '#56468b' },
    '8': { value: '#6958ad' },
    '9': { value: '#6e56cf' },
    '10': { value: '#7d66d9' },
    '11': { value: '#baa7ff' },
    '12': { value: '#e2ddfe' },
    a1: { value: '#4422ff0f' },
    a2: { value: '#853ff916' },
    a3: { value: '#8354fe36' },
    a4: { value: '#7d51fd50' },
    a5: { value: '#845ffd5f' },
    a6: { value: '#8f6cfd6d' },
    a7: { value: '#9879ff83' },
    a8: { value: '#977dfea8' },
    a9: { value: '#8668ffcc' },
    a10: { value: '#9176fed7' },
    a11: { value: '#baa7ff' },
    a12: { value: '#e3defffe' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.violet.light.1}', _dark: '{colors.violet.dark.1}' } },
  '2': { value: { _light: '{colors.violet.light.2}', _dark: '{colors.violet.dark.2}' } },
  '3': { value: { _light: '{colors.violet.light.3}', _dark: '{colors.violet.dark.3}' } },
  '4': { value: { _light: '{colors.violet.light.4}', _dark: '{colors.violet.dark.4}' } },
  '5': { value: { _light: '{colors.violet.light.5}', _dark: '{colors.violet.dark.5}' } },
  '6': { value: { _light: '{colors.violet.light.6}', _dark: '{colors.violet.dark.6}' } },
  '7': { value: { _light: '{colors.violet.light.7}', _dark: '{colors.violet.dark.7}' } },
  '8': { value: { _light: '{colors.violet.light.8}', _dark: '{colors.violet.dark.8}' } },
  '9': { value: { _light: '{colors.violet.light.9}', _dark: '{colors.violet.dark.9}' } },
  '10': { value: { _light: '{colors.violet.light.10}', _dark: '{colors.violet.dark.10}' } },
  '11': { value: { _light: '{colors.violet.light.11}', _dark: '{colors.violet.dark.11}' } },
  '12': { value: { _light: '{colors.violet.light.12}', _dark: '{colors.violet.dark.12}' } },
  a1: { value: { _light: '{colors.violet.light.a1}', _dark: '{colors.violet.dark.a1}' } },
  a2: { value: { _light: '{colors.violet.light.a2}', _dark: '{colors.violet.dark.a2}' } },
  a3: { value: { _light: '{colors.violet.light.a3}', _dark: '{colors.violet.dark.a3}' } },
  a4: { value: { _light: '{colors.violet.light.a4}', _dark: '{colors.violet.dark.a4}' } },
  a5: { value: { _light: '{colors.violet.light.a5}', _dark: '{colors.violet.dark.a5}' } },
  a6: { value: { _light: '{colors.violet.light.a6}', _dark: '{colors.violet.dark.a6}' } },
  a7: { value: { _light: '{colors.violet.light.a7}', _dark: '{colors.violet.dark.a7}' } },
  a8: { value: { _light: '{colors.violet.light.a8}', _dark: '{colors.violet.dark.a8}' } },
  a9: { value: { _light: '{colors.violet.light.a9}', _dark: '{colors.violet.dark.a9}' } },
  a10: { value: { _light: '{colors.violet.light.a10}', _dark: '{colors.violet.dark.a10}' } },
  a11: { value: { _light: '{colors.violet.light.a11}', _dark: '{colors.violet.dark.a11}' } },
  a12: { value: { _light: '{colors.violet.light.a12}', _dark: '{colors.violet.dark.a12}' } },
  default: { value: { _light: '{colors.violet.light.9}', _dark: '{colors.violet.dark.9}' } },
  emphasized: { value: { _light: '{colors.violet.light.10}', _dark: '{colors.violet.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.violet.light.a11}', _dark: '{colors.violet.dark.a11}' } },
})

export default {
  name: 'violet',
  tokens,
  semanticTokens,
}
